import { Button } from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import RemoveIcon from "@material-ui/icons/Remove";
import React from "react";
import "./PartidaCategoryTree.scss";

const categoryKey = (id) => String(id || "").toLowerCase();

export default function PartidaCategoryTree({
	panelRef,
	className = "",
	style,
	rootCategories = [],
	categories = [],
	selectedRoot,
	selectedSubcategoryId = "",
	expandedCategoryIds = new Set(),
	showAllCategories = false,
	onSelectAll,
	onSelectRoot,
	onSelectSubcategory,
	onToggleCategory,
	onCreateSubcategory,
}) {
	const selectedRootId = categoryKey(selectedRoot?.id);
	const selectedChildId = categoryKey(selectedSubcategoryId);

	return (
		<aside
			ref={panelRef}
			className={`partidas-category-panel ${className}`}
			aria-label="Categorías de partidas"
			style={style}
		>
			<div className="partidas-category-heading">Categorías</div>
			<div className="partidas-category-scroll">
				{showAllCategories && (
					<button
						type="button"
						className={`partidas-category-node ${!selectedRoot ? "is-active" : ""}`}
						aria-pressed={!selectedRoot}
						onClick={onSelectAll}
					>
						Todas las categorías
					</button>
				)}
				{rootCategories.map((category) => {
					const children = categories
						.filter((child) => categoryKey(child.categoria_padre_id) === categoryKey(category.id))
						.sort((a, b) => (a.descripcion || "").localeCompare(b.descripcion || "", "es", { sensitivity: "base" }));
					const expanded = expandedCategoryIds.has(category.id);
					const rootActive = selectedRootId === categoryKey(category.id) && !selectedChildId;
					return (
						<div key={category.id}>
							<div className="partidas-category-row">
								{children.length ? (
									<button
										type="button"
										className="partidas-category-toggle"
										aria-label={`${expanded ? "Contraer" : "Expandir"} ${category.descripcion}`}
										aria-expanded={expanded}
										onClick={() => onToggleCategory(category.id)}
									>
										{expanded ? <RemoveIcon fontSize="small" /> : <AddIcon fontSize="small" />}
									</button>
								) : <span className="partidas-category-toggle-placeholder" />}
								<button
									type="button"
									className={`partidas-category-node ${rootActive ? "is-active" : ""}`}
									aria-pressed={rootActive}
									title={category.descripcion}
									onClick={() => onSelectRoot(category)}
								>
									{category.descripcion}
								</button>
							</div>
							{expanded && children.map((child) => (
								<button
									key={child.id}
									type="button"
									className={`partidas-category-node partidas-category-child ${selectedChildId === categoryKey(child.id) ? "is-active" : ""}`}
									aria-pressed={selectedChildId === categoryKey(child.id)}
									title={child.descripcion}
									onClick={() => onSelectSubcategory(category, child)}
								>
									{child.descripcion}
								</button>
							))}
						</div>
					);
				})}
			</div>
			<div className="partidas-category-footer">
				<Button
					variant="outlined"
					color="primary"
					disabled={!selectedRoot}
					onClick={onCreateSubcategory}
				>
					Nueva subcategoría
				</Button>
			</div>
		</aside>
	);
}
